import React, { useState, useEffect } from "react";
import EnviarLaudo from "../components/EnviarLaudo";
import { liberarLaudo } from "../services/planoService";
import { temAcessoEnvio } from "../utils/envioLaudo";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { desenharCabecalhoLaudo, desenharAssinatura } from "../utils/pdfCabecalho";
import { carimbarMarcaVenoAI } from "../utils/pdfMarca";
import { appendImagesToPdf } from "../utils/pdfImages";
import { FiMousePointer, FiPaperclip, FiX } from "react-icons/fi";
import { FaStethoscope } from "react-icons/fa";
import ExamHeader from "../components/ExamHeader";
import laudoSyncService from '../services/laudoSyncService';
import examesRealtimeService from '../services/examesRealtimeService';
import EsquemaMapeamentoModal, { adicionarEsquemaAoPdf } from "../components/EsquemaMapeamentoModal";
import { SafenaMagnaExtra, SafenaParvaExtra } from "../components/SafenaExtraFields";
import VarizesRegioes from "../components/VarizesRegioes";
import MapaInterativo from "../components/MapaInterativo";
import {
  veiasProfundas, veiasSuperficiais, profOptions, supOptions,
  perfurantesStatusOptions, perfurantesSegmentoOptions,
  montarLaudo, varizesVazias, normalizarVarizesLado,
} from "../utils/mmiiVenosoLaudo";
import { confirmarPdfELimpar } from "../utils/limparAposPdf";

// Constantes para localStorage
const STORAGE_KEY = "examesMMIIVenoso";

// Funções para gerenciar exames salvos
async function salvarExame(dadosExame) {
  try {
    // Salvar usando o serviço em tempo real
    const resultado = await examesRealtimeService.criarExame({
      ...dadosExame,
      tipoNome: "Doppler Venoso de Membros Inferiores"
    });
    
    if (resultado.success) {
      console.log("Exame salvo com sucesso!");
      return true;
    } else {
      console.warn("Erro ao salvar exame, salvando localmente:", resultado.error);
      // Fallback: salvar localmente
      return salvarExameLocal(dadosExame);
    }
  } catch (error) {
    console.error("Erro ao salvar exame:", error);
    // Fallback: salvar localmente
    return salvarExameLocal(dadosExame);
  }
}

// Função de fallback para salvar localmente
function salvarExameLocal(dadosExame) {
  try {
    const examesExistentes = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    const novoExame = {
      ...dadosExame,
      id: Date.now().toString(),
      timestamp: new Date().toISOString(),
      tipo: STORAGE_KEY
    };
    
    examesExistentes.push(novoExame);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(examesExistentes));
    return true;
  } catch (error) {
    console.error("Erro ao salvar exame localmente:", error);
    return false;
  }
}

function carregarExameEmEdicao() {
  try {
    const exameEmEdicao = localStorage.getItem("exameEmEdicao");
    if (exameEmEdicao) {
      const exame = JSON.parse(exameEmEdicao);
      localStorage.removeItem("exameEmEdicao"); // Limpar após carregar
      return exame;
    }
    return null;
  } catch (error) {
    console.error("Erro ao carregar exame em edição:", error);
    return null;
  }
}

const lados = ["Direito", "Esquerdo", "Ambos"];

// Bloco de campos por lado
function BlocoCampos({ lado, profundas, superficiais, magna, parva, perfurantes, onProfundas, onSuperficiais, onMagna, onParva, onPerfurantes, jsfDiametro, setJsfDiametro, jspDiametro, setJspDiametro, observacao, onObservacao, varizes, onVarizes, onAbrirMapa }) {
  return (
    <div style={{
      marginBottom: 'clamp(12px, 2vw, 16px)', 
      width: '100%', 
      padding: 'clamp(12px, 2.5vw, 16px) clamp(14px, 3vw, 20px)', 
      boxSizing: 'border-box', 
      background: 'rgba(0,0,0,0.10)', 
      borderRadius: 'clamp(8px, 1.5vw, 12px)', 
      boxShadow: '0 2px 16px 0 #0002', 
      marginLeft: 'auto', 
      marginRight: 'auto', 
      display: 'flex', 
      flexDirection: 'column', 
      gap: 'clamp(8px, 1.5vw, 12px)'
    }}>
      <div style={{
        marginTop: 'clamp(4px, 1vw, 8px)',
        marginBottom: 'clamp(4px, 1vw, 6px)',
        fontWeight: 700, 
        fontSize: 'clamp(12px, 2.5vw, 14px)'
      }}>
        Sistema Venoso Profundo ({lado}):
      </div>
      {veiasProfundas.map(veia => (
        <div key={veia} style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 'clamp(6px, 1.5vw, 8px)', 
          marginBottom: 'clamp(3px, 1vw, 4px)', 
          flexWrap: 'wrap' 
        }}>
          <label style={{ 
            minWidth: 'clamp(120px, 20vw, 160px)', 
            fontSize: 'clamp(11px, 2.2vw, 13px)' 
          }}>{veia}:</label>
          <select 
            value={profundas[veia]} 
            onChange={e=>onProfundas({...profundas, [veia]:e.target.value})} 
            style={{
              flex: 1, 
              minWidth: 'clamp(120px, 25vw, 150px)', 
              maxWidth: 'clamp(300px, 40vw, 400px)', 
              padding: 'clamp(3px, 1vw, 4px)', 
              borderRadius: 'clamp(3px, 1vw, 4px)', 
              fontSize: 'clamp(11px, 2.2vw, 13px)'
            }}
          >
            {profOptions.map(opt=><option key={opt}>{opt}</option>)}
          </select>
        </div>
      ))}
      <div style={{
        marginTop: 'clamp(12px, 2.5vw, 16px)',
        fontWeight: 700, 
        fontSize: 'clamp(12px, 2.5vw, 14px)'
      }}>
        Sistema Venoso Superficial ({lado}):
      </div>
      {veiasSuperficiais.map(veia => (
        <div key={veia} style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 'clamp(6px, 1.5vw, 8px)', 
          marginBottom: 'clamp(3px, 1vw, 4px)', 
          flexWrap: 'wrap', 
          width: '100%' 
        }}>
          <label style={{ 
            minWidth: 'clamp(120px, 20vw, 160px)', 
            fontSize: 'clamp(11px, 2.2vw, 13px)' 
          }}>{veia}:</label>
          <select
            value={superficiais[veia]}
            onChange={e=>onSuperficiais({...superficiais, [veia]:e.target.value})}
            style={{
              flex: 1, 
              minWidth: 'clamp(120px, 25vw, 150px)', 
              maxWidth: 'clamp(300px, 40vw, 400px)', 
              padding: 'clamp(3px, 1vw, 4px)', 
              borderRadius: 'clamp(3px, 1vw, 4px)', 
              fontSize: 'clamp(11px, 2.2vw, 13px)'
            }}
          >
            {supOptions.map(opt=><option key={opt}>{opt}</option>)}
          </select>
          {(veia === "JSF") && (
            <input 
              type="number" 
              min={0} 
              step={0.1} 
              placeholder="Diâmetro (mm)" 
              value={jsfDiametro || ""} 
              onChange={e => setJsfDiametro(e.target.value)} 
              style={{ 
                width: 'clamp(80px, 15vw, 100px)', 
                marginLeft: 'clamp(4px, 1.5vw, 6px)', 
                borderRadius: 'clamp(3px, 1vw, 4px)', 
                border: "1px solid #0eb8d0", 
                padding: 'clamp(3px, 1vw, 4px)', 
                fontSize: 'clamp(11px, 2.2vw, 13px)' 
              }} 
            />
          )}
          {(veia === "JSP") && (
            <input 
              type="number" 
              min={0} 
              step={0.1} 
              placeholder="Diâmetro (mm)" 
              value={jspDiametro || ""} 
              onChange={e => setJspDiametro(e.target.value)} 
              style={{ 
                width: 'clamp(80px, 15vw, 100px)', 
                marginLeft: 'clamp(4px, 1.5vw, 6px)', 
                borderRadius: 'clamp(3px, 1vw, 4px)', 
                border: "1px solid #0eb8d0", 
                padding: 'clamp(3px, 1vw, 4px)', 
                fontSize: 'clamp(11px, 2.2vw, 13px)' 
              }} 
            />
          )}
          {veia === "Safena Magna" && (
            <div style={{ width: '100%' }}>
              <SafenaMagnaExtra status={superficiais[veia]} valores={magna} onChange={onMagna} />
            </div>
          )}
          {veia === "Safena Parva" && (
            <div style={{ width: '100%' }}>
              <SafenaParvaExtra status={superficiais[veia]} valores={parva} onChange={onParva} />
            </div>
          )}
        </div>
      ))}
      {/* Varizes: desenhadas no Mapa; aqui fica o resumo */}
      <div style={{
        marginTop: 'clamp(12px, 2.5vw, 16px)',
        marginBottom: 'clamp(8px, 2vw, 12px)',
        fontWeight: 700,
        fontSize: 'clamp(12px, 2.5vw, 14px)'
      }}>
        Varizes
      </div>
      <VarizesRegioes valores={varizes} onChange={onVarizes} onAbrirMapa={onAbrirMapa} />
      {/* Bloco de veias perfurantes (lista - permite múltiplas por lado) */}
      <div style={{
        marginTop: 'clamp(12px, 2.5vw, 16px)',
        fontWeight: 700,
        fontSize: 'clamp(12px, 2.5vw, 14px)'
      }}>Veias Perfurantes ({lado}):</div>
      {perfurantes.map((perf, idx) => (
        <div key={idx} style={{
          border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: 'clamp(4px, 1vw, 6px)',
          padding: 'clamp(6px, 1.5vw, 8px)',
          marginBottom: 'clamp(6px, 1.5vw, 8px)',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'clamp(6px, 1.5vw, 8px)',
            marginBottom: 'clamp(3px, 1vw, 4px)',
            flexWrap: 'wrap'
          }}>
            <label style={{
              minWidth: 'clamp(120px, 20vw, 160px)',
              fontSize: 'clamp(11px, 2.2vw, 13px)'
            }}>Perfurante {idx + 1}:</label>
            <select
              value={perf.status}
              onChange={e => onPerfurantes(perfurantes.map((p, i) => i === idx ? (
                e.target.value === "pérvia e incompetente"
                  ? { ...p, status: e.target.value }
                  : { ...p, status: e.target.value, segmento: "", valor: "" }
              ) : p))}
              style={{
                flex: 1,
                minWidth: 'clamp(120px, 25vw, 150px)',
                maxWidth: 'clamp(300px, 40vw, 400px)',
                padding: 'clamp(3px, 1vw, 4px)',
                borderRadius: 'clamp(3px, 1vw, 4px)',
                fontSize: 'clamp(11px, 2.2vw, 13px)'
              }}
            >
              {perfurantesStatusOptions.map(opt => <option key={opt}>{opt}</option>)}
            </select>
            {perfurantes.length > 1 && (
              <button
                type="button"
                onClick={() => onPerfurantes(perfurantes.filter((_, i) => i !== idx))}
                style={{
                  padding: 'clamp(3px, 1vw, 4px) clamp(6px, 1.5vw, 8px)',
                  borderRadius: 'clamp(3px, 1vw, 4px)',
                  border: 'none',
                  background: '#c0392b',
                  color: '#fff',
                  fontSize: 'clamp(11px, 2.2vw, 13px)',
                  cursor: 'pointer',
                }}
              >Remover</button>
            )}
          </div>
          {perf.status === "pérvia e incompetente" && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'clamp(6px, 1.5vw, 8px)',
              marginBottom: 'clamp(3px, 1vw, 4px)',
              flexWrap: 'wrap',
              marginLeft: 'clamp(8px, 2vw, 12px)'
            }}>
              <select
                value={perf.segmento}
                onChange={e => onPerfurantes(perfurantes.map((p, i) => i === idx ? { ...p, segmento: e.target.value, valor: "" } : p))}
                style={{
                  minWidth: 'clamp(120px, 25vw, 150px)',
                  maxWidth: 'clamp(180px, 30vw, 220px)',
                  padding: 'clamp(3px, 1vw, 4px)',
                  borderRadius: 'clamp(3px, 1vw, 4px)',
                  fontSize: 'clamp(11px, 2.2vw, 13px)'
                }}
              >
                <option value="">Selecione o segmento</option>
                {perfurantesSegmentoOptions.map(opt => <option key={opt}>{opt}</option>)}
              </select>
              {perf.segmento && (
                <input
                  type="number"
                  min={0}
                  step={0.1}
                  value={perf.valor}
                  onChange={e => onPerfurantes(perfurantes.map((p, i) => i === idx ? { ...p, valor: e.target.value } : p))}
                  placeholder="cm"
                  style={{
                    width: 'clamp(50px, 10vw, 60px)',
                    marginLeft: 'clamp(3px, 1vw, 4px)',
                    borderRadius: 'clamp(3px, 1vw, 4px)',
                    padding: 'clamp(3px, 1vw, 4px)',
                    border: '1.5px solid #0eb8d0',
                    fontSize: 'clamp(11px, 2.2vw, 13px)'
                  }}
                />
              )}
            </div>
          )}
        </div>
      ))}
      <button
        type="button"
        onClick={() => onPerfurantes([...perfurantes, { status: "pérvia e competente", segmento: "", valor: "" }])}
        style={{
          padding: 'clamp(4px, 1vw, 6px) clamp(8px, 2vw, 10px)',
          borderRadius: 'clamp(3px, 1vw, 4px)',
          border: '1.5px solid #0eb8d0',
          background: 'transparent',
          color: '#0eb8d0',
          fontSize: 'clamp(11px, 2.2vw, 13px)',
          fontWeight: 600,
          cursor: 'pointer',
          marginBottom: 'clamp(6px, 1.5vw, 8px)',
        }}
      >+ Adicionar perfurante</button>
      {/* Caixa de Observação por membro */}
      <div style={{ width: '100%', marginTop: 'clamp(6px, 1.5vw, 8px)' }}>
        <label style={{ 
          fontWeight: 600, 
          fontSize: 'clamp(12px, 2.5vw, 14px)', 
          marginBottom: 'clamp(3px, 1vw, 4px)', 
          display: 'block' 
        }}>Observações ({lado}):</label>
        <textarea
          value={observacao || ''}
          onChange={e => onObservacao(e.target.value)}
          placeholder={`Digite observações adicionais do exame do membro ${lado.toLowerCase()}...`}
          style={{ 
            width: '100%', 
            minHeight: 'clamp(40px, 8vw, 50px)', 
            fontSize: 'clamp(11px, 2.2vw, 13px)', 
            borderRadius: 'clamp(4px, 1vw, 6px)', 
            border: '1.5px solid #0eb8d0', 
            padding: 'clamp(6px, 1.5vw, 8px)', 
            resize: 'vertical', 
            marginTop: 'clamp(1px, 0.5vw, 2px)' 
          }}
        />
      </div>
    </div>
  );
}

function MMIIVenoso() {
  const [nome, setNome] = useState("");
  const [enviandoLaudo, setEnviandoLaudo] = useState(false);
  const [idade, setIdade] = useState("");
  const [data, setData] = useState("");
  const [lado, setLado] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const ladosIndividuais = ["Direito", "Esquerdo"];
  const [profundas, setProfundas] = useState({
    Direito: Object.fromEntries(veiasProfundas.map(v=>[v, profOptions[0]])),
    Esquerdo: Object.fromEntries(veiasProfundas.map(v=>[v, profOptions[0]])),
  });
  const [superficiais, setSuperficiais] = useState({
    Direito: Object.fromEntries(veiasSuperficiais.map(v=>[v, supOptions[0]])),
    Esquerdo: Object.fromEntries(veiasSuperficiais.map(v=>[v, supOptions[0]])),
  });
  const [magna, setMagna] = useState({
    Direito: {coxa:"",perna:"",tornozelo:"",inicio:"",inicio_valor:"",fim:"",fim_valor:""},
    Esquerdo: {coxa:"",perna:"",tornozelo:"",inicio:"",inicio_valor:"",fim:"",fim_valor:""},
  });
  const [parva, setParva] = useState({
    Direito: {proximal:"",distal:"",inicio:"",inicio_valor:"",fim:"",fim_valor:""},
    Esquerdo: {proximal:"",distal:"",inicio:"",inicio_valor:"",fim:"",fim_valor:""},
  });
  const [perfurantes, setPerfurantes] = useState({
    Direito: [{ status: "pérvia e competente", segmento: "", valor: "" }],
    Esquerdo: [{ status: "pérvia e competente", segmento: "", valor: "" }]
  });
  const [observacoes, setObservacoes] = useState({ Direito: '', Esquerdo: '' });
  const [laudoTexto, setLaudoTexto] = useState("");
  const [jsfDiametro, setJsfDiametro] = useState({ Direito: "", Esquerdo: "" });
  const [jspDiametro, setJspDiametro] = useState({ Direito: "", Esquerdo: "" });
  const [erro, setErro] = useState("");
  const [varizes, setVarizes] = useState({ Direito: varizesVazias(), Esquerdo: varizesVazias() });
  const [anexos, setAnexos] = useState([]);
  const [mostrarEsquema, setMostrarEsquema] = useState(false);
  const [incluirEsquemaPdf, setIncluirEsquemaPdf] = useState(false);
  // O Mapa Interativo é a tela principal do exame: abre sozinho assim que o
  // cabeçalho (nome, idade, data e lado) está completo. "Ver formulário"
  // mostra os quadros de preenchimento no lugar dele.
  const [mostrarMapa, setMostrarMapa] = useState(true);
  const [ladoMapa, setLadoMapa] = useState("Direito");
  useEffect(() => {
    setLadoMapa(lado === "Esquerdo" ? "Esquerdo" : "Direito");
  }, [lado]);
  const cabecalhoCompleto = !!(nome && nome.trim() && idade && data && lado);
  const mapaAtivo = cabecalhoCompleto && mostrarMapa;

  // Hook para detectar mudanças no tamanho da tela
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // Hook para carregar exame em edição
  useEffect(() => {
    const exameEmEdicao = carregarExameEmEdicao();
    if (exameEmEdicao) {
      setNome(exameEmEdicao.nome || "");
      setIdade(exameEmEdicao.idade || "");
      setData(exameEmEdicao.data || "");
      setLado(exameEmEdicao.lado || "");
      
      if (exameEmEdicao.profundas) setProfundas(exameEmEdicao.profundas);
      if (exameEmEdicao.superficiais) setSuperficiais(exameEmEdicao.superficiais);
      if (exameEmEdicao.magna) setMagna(exameEmEdicao.magna);
      if (exameEmEdicao.parva) setParva(exameEmEdicao.parva);
      if (exameEmEdicao.perfurantes) {
        const migrarPerfurantes = (v) => Array.isArray(v) ? v : (v && v.status ? [v] : []);
        setPerfurantes({
          Direito: migrarPerfurantes(exameEmEdicao.perfurantes.Direito),
          Esquerdo: migrarPerfurantes(exameEmEdicao.perfurantes.Esquerdo),
        });
      }
      if (exameEmEdicao.observacoes) setObservacoes(exameEmEdicao.observacoes);
      if (exameEmEdicao.jsfDiametro) setJsfDiametro(exameEmEdicao.jsfDiametro);
      if (exameEmEdicao.jspDiametro) setJspDiametro(exameEmEdicao.jspDiametro);
      if (exameEmEdicao.varizes) {
        // Exames antigos ({coxa, perna...} ou {tipo, localizacao}) viram os 16 pontos.
        const migrarVarizes = normalizarVarizesLado;
        setVarizes({
          Direito: migrarVarizes(exameEmEdicao.varizes.Direito),
          Esquerdo: migrarVarizes(exameEmEdicao.varizes.Esquerdo),
        });
      }

      // Se já tem laudo, mostrar
      if (exameEmEdicao.laudo) {
        setLaudoTexto(exameEmEdicao.laudo);
      }
    }
  }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    if (name === "nome") setNome(value);
    else if (name === "idade") setIdade(value);
    else if (name === "data") setData(value);
    else if (name === "lado") setLado(value);
  }

  function handleVisualizar() {
    setErro("");
    if (!nome || !data || !lado) {
      setErro("Preencha nome, data e lado antes de visualizar o laudo!");
      return;
    }
    const laudo = montarLaudo({ nome, data, lado, profundas, superficiais, magna, parva, jsfDiametro, jspDiametro, observacoes, perfurantes, varizes });
    setLaudoTexto(laudo);
  }

  async function handleSalvarExame() {
    setErro("");
    if (!nome || !data || !lado) {
      setErro("Preencha nome, data e lado antes de salvar o exame!");
      return;
    }
    if (!(await liberarLaudo({ tipoNome: "Doppler Venoso de Membros Inferiores", nome, data }))) return;
    
    // Gera o laudo sempre a partir do estado atual (e não do laudoTexto já
    // exibido), pra garantir que reflita edições feitas depois de
    // "Visualizar Laudo" — por exemplo, ajustes feitos no Mapa Interativo.
    const laudo = montarLaudo({ nome, data, lado, profundas, superficiais, magna, parva, jsfDiametro, jspDiametro, observacoes, perfurantes, varizes });

    const dadosExame = {
      nome,
      idade,
      data,
      lado,
      profundas,
      superficiais,
      magna,
      parva,
      perfurantes,
      observacoes,
      jsfDiametro,
      jspDiametro,
      varizes,
      laudo,
      tipoNome: "Doppler Venoso de Membros Inferiores"
    };
    
    try {
      const sucesso = await salvarExame(dadosExame);
      if (sucesso) {
        alert("Exame salvo com sucesso!");
      } else {
        setErro("Erro ao salvar o exame. Tente novamente.");
      }
    } catch (error) {
      console.error("Erro ao salvar exame:", error);
      setErro("Erro ao salvar o exame. Tente novamente.");
    }
  }

  // Copia os achados estruturados de um lado pro outro (exame bilateral com
  // achado parecido nos dois lados) — não copia observações, que costumam
  // ser um texto livre específico daquele lado.
  function handleCopiarLado(origem, destino) {
    if (!window.confirm(`Copiar todos os achados de ${origem} para ${destino}? Isso substitui o que já estiver preenchido em ${destino}.`)) {
      return;
    }
    const clonar = (obj) => JSON.parse(JSON.stringify(obj));
    setProfundas(prev => ({ ...prev, [destino]: clonar(prev[origem]) }));
    setSuperficiais(prev => ({ ...prev, [destino]: clonar(prev[origem]) }));
    setMagna(prev => ({ ...prev, [destino]: clonar(prev[origem]) }));
    setParva(prev => ({ ...prev, [destino]: clonar(prev[origem]) }));
    setPerfurantes(prev => ({ ...prev, [destino]: clonar(prev[origem]) }));
    setJsfDiametro(prev => ({ ...prev, [destino]: prev[origem] }));
    setJspDiametro(prev => ({ ...prev, [destino]: prev[origem] }));
    setVarizes(prev => ({ ...prev, [destino]: clonar(prev[origem]) }));
  }

  // Gera o TXT sempre a partir do estado atual (e não do laudoTexto já
  // exibido), pra garantir que reflita edições feitas depois de
  // "Visualizar Laudo" — por exemplo, ao salvar direto de dentro do Mapa
  // Interativo, sem precisar fechá-lo antes.
  async function handleSalvarTXT() {
    if (!nome || !data || !lado) {
      alert("Preencha nome, data e lado antes de salvar o exame!");
      return;
    }
    if (!(await liberarLaudo({ tipoNome: "Doppler Venoso de Membros Inferiores", nome, data }))) return;
    const laudo = montarLaudo({ nome, data, lado, profundas, superficiais, magna, parva, jsfDiametro, jspDiametro, observacoes, perfurantes, varizes });
    const blob = new Blob([laudo], { type: "text/plain;charset=utf-8" });
    saveAs(blob, `Laudo_${nome}_${data}.txt`);
  }

  // Gera e salva o PDF completo (mesma lógica usada pelo botão "Salvar PDF"
  // do formulário principal), sempre a partir do estado atual — permite
  // chamar isso também de dentro do Mapa Interativo.
  async function handleSalvarPDF(opcoes = {}) {
    const paraEnvio = !!(opcoes && opcoes.retornarBlob);
    if (!nome || !data || !lado) {
      if (paraEnvio) return null;
      alert("Preencha nome, data e lado antes de salvar o exame!");
      return;
    }
    // "Salvar PDF" baixa o PDF e já limpa o formulário pro próximo paciente
    // (não dá pra desfazer) — confirma antes pra evitar perder o que estava
    // preenchido se o clique foi sem querer ou antes de revisar tudo.
    if (!paraEnvio && !confirmarPdfELimpar()) {
      return;
    }
    if (!(await liberarLaudo({ tipoNome: "Doppler Venoso de Membros Inferiores", nome, data }))) return opcoes && opcoes.retornarBlob ? { bloqueado: true } : undefined;
    const laudo = montarLaudo({ nome, data, lado, profundas, superficiais, magna, parva, jsfDiametro, jspDiametro, observacoes, perfurantes, varizes });
    // Buscar dados do localStorage
    const nomeMedico = localStorage.getItem("nomeMedico") || "";
    const crm = localStorage.getItem("crm") || "";
    const especialidade = localStorage.getItem("especialidadeLaudo") || "";
    const nomeClinica = localStorage.getItem("nomeClinica") || "";
    const enderecoClinica = localStorage.getItem("enderecoClinica") || "";
    const telefoneClinica = localStorage.getItem("telefoneClinica") || "";
    const emailClinica = localStorage.getItem("emailClinica") || "";
    const logoClinica = localStorage.getItem("logoClinica") || null;
    const assinaturaMedico = localStorage.getItem("assinaturaMedico") || null;

    const doc = new jsPDF();
    const lados = lado === "Ambos" ? ["Direito", "Esquerdo"] : [lado];
    const blocos = laudo.split("=".repeat(80));
    // Fonte do corpo do laudo: 11, ou 10 quando é preciso para caber numa página.
    let fonteCorpo = 11;

    function addCabecalho() {
      // logo à esquerda (proporcional) e dados da clínica à direita
      return desenharCabecalhoLaudo(doc, {
        logo: logoClinica,
        linhas: [nomeClinica, enderecoClinica, telefoneClinica && "Tel: " + telefoneClinica, emailClinica],
        fonteCorpo,
      });
    }

    function addRodape() {
      const yRodape = 280; // margem inferior de 1cm
      doc.setFontSize(8);
      desenharAssinatura(doc, assinaturaMedico, yRodape);
      doc.text("Assinatura: ________________", 200, yRodape, { align: "right" });
      let yInfo = yRodape + 5;
      if (nomeMedico) { doc.setFont(undefined, "bold"); doc.text(nomeMedico, 200, yInfo, { align: "right" }); yInfo += 4; }
      if (crm) { doc.setFont(undefined, "normal"); doc.text("CRM: " + crm, 200, yInfo, { align: "right" }); yInfo += 4; }
      if (especialidade) { doc.setFont(undefined, "normal"); doc.text(especialidade, 200, yInfo, { align: "right" }); yInfo += 4; }
      doc.setFontSize(fonteCorpo);
    }

    // Função auxiliar para quebrar conclusão por travessões
    function processarConclusao(texto) {
      // Se a linha contém múltiplos travessões, quebrar em linhas separadas
      if (texto.includes('- ') && texto.split('- ').length > 2) {
        // Remove o primeiro travessão se já existir
        const partes = texto.split('- ').filter(p => p.trim() !== '');
        return partes.map(p => p.trim()).filter(p => p !== '');
      }
      return [texto];
    }

    // Função auxiliar para quebrar texto longo respeitando margens
    function quebrarTexto(texto, maxWidth, x) {
      if (!texto || texto.trim() === '') return [''];
      const pageWidth = doc.internal.pageSize.getWidth();
      const margemEsquerda = x || 15;
      const margemDireita = 15;
      const larguraDisponivel = pageWidth - margemEsquerda - margemDireita;

      // Usar splitTextToSize do jsPDF - ele calcula automaticamente baseado na fonte atual
      try {
        const linhas = doc.splitTextToSize(texto, larguraDisponivel);
        // Garantir que sempre retorna um array
        return Array.isArray(linhas) ? linhas : [linhas];
      } catch (e) {
        console.warn('Erro ao quebrar texto com splitTextToSize:', e);
        // Fallback: quebrar manualmente por caracteres
        const linhas = [];
        // Aproximação conservadora: ~3mm por caractere para fonte padrão
        const maxChars = Math.max(1, Math.floor(larguraDisponivel / 3));
        for (let i = 0; i < texto.length; i += maxChars) {
          linhas.push(texto.substring(i, i + maxChars));
        }
        return linhas.length > 0 ? linhas : [texto];
      }
    }

    let pagina = 0;
    lados.forEach((ladoAtual, idx) => {
      if (pagina > 0) doc.addPage();
      let y = addCabecalho(12);
      const bloco = blocos[idx].trim().split("\n");
      // Espaçamento adaptável: se o membro não cabe numa página com linhas de
      // 8 mm, aproxima as linhas (até 5,2 mm) e, se ainda faltar espaço, usa
      // fonte 10 (até 4,8 mm). Linha em branco ocupa meia linha. Assim a
      // conclusão não "pula" sozinha para a página seguinte.
      const limite = assinaturaMedico ? 265 : 270;
      const contarLinhas = () => {
        doc.setFont(undefined, "bold");
        const n = bloco.reduce((acc, l) => acc + (l.trim() === "" ? 0.5 : quebrarTexto(l, 0, 15).length), 0);
        doc.setFont(undefined, "normal");
        return n + 1; // folga para quebras de linha que a conta não prevê
      };
      fonteCorpo = 11;
      doc.setFontSize(fonteCorpo);
      let passo = Math.min(8, (limite - y) / contarLinhas());
      if (passo < 5.2) {
        fonteCorpo = 10;
        doc.setFontSize(fonteCorpo);
        passo = Math.max(4.8, Math.min(8, (limite - y) / contarLinhas()));
      }
      let inConclusao = false;
      let inObservacoes = false;
      for (let i = 0; i < bloco.length; i++) {
        let line = bloco[i];
        // Negrito para nome do paciente e nome do exame
        if (line.startsWith("PACIENTE:")) {
          doc.setFont(undefined, "bold");
          const linhasQuebradas = quebrarTexto(line, 0, 15);
          linhasQuebradas.forEach(linha => {
            doc.text(linha, 15, y);
            y += passo;
          });
          doc.setFont(undefined, "normal");
          y -= passo; // Ajuste para não ter espaço extra
        } else if (line.startsWith("DOPPLER VENOSO DE MEMBRO INFERIOR")) {
          doc.setFont(undefined, "bold");
          const linhasQuebradas = quebrarTexto(line, 0, 15);
          linhasQuebradas.forEach(linha => {
            doc.text(linha, 15, y);
            y += passo;
          });
          doc.setFont(undefined, "normal");
          y -= passo; // Ajuste para não ter espaço extra
        } else if (line.startsWith("CONCLUSÃO") || line.startsWith("Sistema Venoso Profundo") || line.startsWith("Sistema Venoso Superficial")) {
          doc.setFont(undefined, "bold");
          const linhasQuebradas = quebrarTexto(line, 0, 15);
          linhasQuebradas.forEach(linha => {
            doc.text(linha, 15, y);
            y += passo;
          });
          if (line.startsWith("CONCLUSÃO")) {
            inConclusao = true;
            inObservacoes = false;
          }
          doc.setFont(undefined, "normal");
          y -= passo; // Ajuste para não ter espaço extra
        } else if (line.startsWith("OBSERVAÇÕES")) {
          doc.setFont(undefined, "bold");
          doc.text(line, 15, y);
          doc.setFont(undefined, "normal");
          inConclusao = false;
          inObservacoes = true;
        } else if (inConclusao && line.trim() !== "" && !line.startsWith("OBSERVAÇÕES") && !line.startsWith("=")) {
          // Processar conclusão: quebrar por travessões
          const linhasConclusao = processarConclusao(line);
          doc.setFont(undefined, "bold");
          linhasConclusao.forEach(linhaConclusao => {
            // Garantir que cada item comece com travessão
            const linhaFormatada = linhaConclusao.startsWith('-') ? linhaConclusao : `- ${linhaConclusao}`;
            const linhasQuebradas = quebrarTexto(linhaFormatada, 0, 15);
            linhasQuebradas.forEach(linha => {
              if (y > limite) {
                addRodape();
                doc.addPage();
                y = addCabecalho(12);
              }
              doc.text(linha, 15, y);
              y += passo;
            });
          });
          doc.setFont(undefined, "normal");
          y -= passo; // Ajuste para não ter espaço extra
        } else if (inObservacoes && line.trim() !== "") {
          // Quebrar observações longas respeitando margens
          doc.setFont(undefined, "normal");
          const linhasQuebradas = quebrarTexto(line, 0, 15);
          linhasQuebradas.forEach(linha => {
            if (y > limite) {
              addRodape();
              doc.addPage();
              y = addCabecalho(12);
            }
            doc.text(linha, 15, y);
            y += passo;
          });
          y -= passo; // Ajuste para não ter espaço extra
        } else {
          doc.setFont(undefined, "normal");
          // Quebrar linhas longas também
          const linhasQuebradas = quebrarTexto(line, 0, 15);
          linhasQuebradas.forEach(linha => {
            if (y > limite) {
              addRodape();
              doc.addPage();
              y = addCabecalho(12);
            }
            doc.text(linha, 15, y);
            y += passo;
          });
          if (inConclusao && line.trim() === "") {
            inConclusao = false;
          }
          if (inObservacoes && line.trim() === "") {
            inObservacoes = false;
          }
          y -= passo; // Ajuste para não ter espaço extra
        }
        y += line.trim() === "" ? passo / 2 : passo;
        if (y > limite && i < bloco.length - 1) {
          addRodape();
          doc.addPage();
          y = addCabecalho(12);
        }
      }
      addRodape();
      pagina++;
    });


    if (incluirEsquemaPdf) {
      try {
        await adicionarEsquemaAoPdf(doc, {
          ladosParaMostrar: lados,
          superficiais,
          magna,
          parva,
          perfurantes,
          profundas,
          varizes,
          observacoes,
        });
      } catch (e) {
        console.error('Erro ao adicionar esquema de mapeamento ao PDF:', e);
      }
    }

    // Anexos por último (depois do mapeamento), sem distorcer as fotos.
    appendImagesToPdf(doc, anexos);

    carimbarMarcaVenoAI(doc);
    const nomeArquivoPdf = `Laudo_${nome}_${data}.pdf`;
    // "Enviar laudo" usa o mesmo PDF (com mapa e anexos, se marcados)
    if (opcoes && opcoes.retornarBlob) return { blob: doc.output("blob"), nomeArquivo: nomeArquivoPdf };
    doc.save(nomeArquivoPdf);
    // Como avisa a confirmação: PDF baixado, formulário limpo pro próximo paciente.
    limparFormulario();
  }

  // Volta tudo ao estado inicial da página (mesmos valores dos useState).
  function limparFormulario() {
    setNome("");
    setIdade("");
    setData("");
    setLado("");
    setProfundas({
      Direito: Object.fromEntries(veiasProfundas.map(v=>[v, profOptions[0]])),
      Esquerdo: Object.fromEntries(veiasProfundas.map(v=>[v, profOptions[0]])),
    });
    setSuperficiais({
      Direito: Object.fromEntries(veiasSuperficiais.map(v=>[v, supOptions[0]])),
      Esquerdo: Object.fromEntries(veiasSuperficiais.map(v=>[v, supOptions[0]])),
    });
    setMagna({
      Direito: {coxa:"",perna:"",tornozelo:"",inicio:"",inicio_valor:"",fim:"",fim_valor:""},
      Esquerdo: {coxa:"",perna:"",tornozelo:"",inicio:"",inicio_valor:"",fim:"",fim_valor:""},
    });
    setParva({
      Direito: {proximal:"",distal:"",inicio:"",inicio_valor:"",fim:"",fim_valor:""},
      Esquerdo: {proximal:"",distal:"",inicio:"",inicio_valor:"",fim:"",fim_valor:""},
    });
    setPerfurantes({
      Direito: [{ status: "pérvia e competente", segmento: "", valor: "" }],
      Esquerdo: [{ status: "pérvia e competente", segmento: "", valor: "" }]
    });
    setObservacoes({ Direito: '', Esquerdo: '' });
    setLaudoTexto("");
    setJsfDiametro({ Direito: "", Esquerdo: "" });
    setJspDiametro({ Direito: "", Esquerdo: "" });
    setErro("");
    setVarizes({ Direito: varizesVazias(), Esquerdo: varizesVazias() });
    setAnexos([]);
    setMostrarEsquema(false);
    setIncluirEsquemaPdf(false);
    setMostrarMapa(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function handleVoltarMenu() {
    window.location.href = '/home';
  }

  function handleConfiguracao() {
    window.location.href = '/configuracoes';
  }

  function handleVisualizarExamesSalvos() {
    window.location.href = '/exames-realizados';
  }

  function handleLogout() {
    // Implementar lógica de logout se necessário
    window.location.href = '/';
  }

  // Funções para gerenciar anexos de imagens
  function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  function validateFile(file) {
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const maxSize = 15 * 1024 * 1024; // 15MB

    if (!validTypes.includes(file.type)) {
      setErro('Apenas arquivos PNG e JPG são permitidos.');
      return false;
    }

    if (file.size > maxSize) {
      setErro('O arquivo deve ter no máximo 15MB.');
      return false;
    }

    return true;
  }

  function handleFileUpload(event) {
    const files = Array.from(event.target.files);
    setErro('');
    
    files.forEach(file => {
      if (validateFile(file)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const newAnexo = {
            id: Date.now() + Math.random(),
            file: file,
            name: file.name,
            size: file.size,
            thumbnail: e.target.result
          };
          setAnexos(prev => [...prev, newAnexo]);
        };
        reader.readAsDataURL(file);
      }
    });
    
    // Limpar o input
    event.target.value = '';
  }

  function handleDrop(event) {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    setErro('');
    
    files.forEach(file => {
      if (validateFile(file)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const newAnexo = {
            id: Date.now() + Math.random(),
            file: file,
            name: file.name,
            size: file.size,
            thumbnail: e.target.result
          };
          setAnexos(prev => [...prev, newAnexo]);
        };
        reader.readAsDataURL(file);
      }
    });
  }

  function handleDragOver(event) {
    event.preventDefault();
  }

  function removeAnexo(id) {
    setAnexos(prev => prev.filter(anexo => anexo.id !== id));
  }

    return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(120deg,#101824 0%,#1c2740 100%)",
      color: "#fff",
      fontFamily: "Segoe UI, Inter, Arial, sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "clamp(8px, 2vw, 20px)",
      boxSizing: "border-box",
      position: "relative"
    }}>
      <ExamHeader
        examTitle="Doppler Venoso de Membros Inferiores"
        nome={nome}
        idade={idade}
        data={data}
        lado={lado}
        onInputChange={handleChange}
        onVisualizar={() => {
          // Lado único: o laudo aparece junto do formulário; no mapa ele já está ao vivo.
          if (mapaAtivo && lado !== "Ambos") setMostrarMapa(false);
          handleVisualizar();
        }}
        onSalvar={handleSalvarExame}
        onVoltarMenu={handleVoltarMenu}
        onConfiguracao={handleConfiguracao}
        onVisualizarExamesSalvos={handleVisualizarExamesSalvos}
        onLogout={handleLogout}
        erro={erro}
      />

      {lado && !mapaAtivo && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 'clamp(10px, 2vw, 14px)' }}>
          <button
            type="button"
            onClick={() => setMostrarMapa(true)}
            style={{ ...buttonStyle, background: "#3d5a80", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6 }}
          >
            <FiMousePointer /> Abrir no VENO.AI Map
          </button>
        </div>
      )}

      <EnviarLaudo

        aberto={enviandoLaudo}

        onFechar={() => setEnviandoLaudo(false)}

        obterPdf={() => handleSalvarPDF({ retornarBlob: true })}

        info={{ paciente: nome, tipoNome: "Doppler Venoso de Membros Inferiores", data }}

      />

      <MapaInterativo
        aberto={mapaAtivo}
        embutido
        onFechar={() => setMostrarMapa(false)}
        lado={lado}
        ladoAtivo={ladoMapa}
        onTrocarLado={setLadoMapa}
        nome={nome}
        data={data}
        profundas={profundas}
        superficiais={superficiais}
        magna={magna}
        parva={parva}
        perfurantes={perfurantes}
        observacoes={observacoes}
        varizes={varizes}
        jsfDiametro={jsfDiametro}
        jspDiametro={jspDiametro}
        onProfundas={(l, val) => setProfundas(prev => ({ ...prev, [l]: val }))}
        onSuperficiais={(l, val) => setSuperficiais(prev => ({ ...prev, [l]: val }))}
        onMagna={(l, val) => setMagna(prev => ({ ...prev, [l]: val }))}
        onParva={(l, val) => setParva(prev => ({ ...prev, [l]: val }))}
        onPerfurantes={(l, val) => setPerfurantes(prev => ({ ...prev, [l]: val }))}
        onJsfDiametro={(l, val) => setJsfDiametro(prev => ({ ...prev, [l]: val }))}
        onJspDiametro={(l, val) => setJspDiametro(prev => ({ ...prev, [l]: val }))}
        onVarizes={(l, val) => setVarizes(prev => ({ ...prev, [l]: val }))}
        onObservacao={(l, val) => setObservacoes(prev => ({ ...prev, [l]: val }))}
        onSalvarExame={handleSalvarExame}
        onSalvarTXT={handleSalvarTXT}
        onSalvarPDF={handleSalvarPDF}
        onEnviar={temAcessoEnvio() ? () => setEnviandoLaudo(true) : undefined}
        onAbrirMapeamentoVisual={() => setMostrarEsquema(true)}
        incluirMapeamentoVisualPdf={incluirEsquemaPdf}
        onIncluirMapeamentoVisualPdf={setIncluirEsquemaPdf}
        anexos={anexos}
        onFileUpload={handleFileUpload}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onRemoveAnexo={removeAnexo}
        formatFileSize={formatFileSize}
      />

      {/* Quadros de preenchimento: só no modo formulário */}
      {!mapaAtivo && (
      <div style={{
        width: '100%',
        maxWidth: 'min(1200px, 98vw)',
        margin: 'clamp(16px, 3vw, 24px) auto 0 auto', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        gap: 'clamp(12px, 2vw, 16px)'
      }}>
        {lado === "Ambos" && (
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 'clamp(6px, 1.5vw, 10px)', flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={() => handleCopiarLado('Direito', 'Esquerdo')}
              style={{ ...buttonStyle, background: '#3d5a80', fontSize: 'clamp(11px, 2vw, 13px)', padding: 'clamp(5px, 1.5vw, 7px) clamp(10px, 2.5vw, 14px)' }}
            >
              Copiar Direito → Esquerdo
            </button>
          </div>
        )}
        <div style={{
          width: '100%',
          display: 'flex',
          gap: 'clamp(12px, 2vw, 20px)',
          flexDirection: isMobile ? 'column' : 'row'
        }}>
          {/* Layout para lado único (Direito ou Esquerdo) */}
          {(lado === "Direito" || lado === "Esquerdo") && (
            <>
              <div style={{
                background: '#18243a', 
                borderRadius: 'clamp(8px, 1.5vw, 12px)', 
                boxShadow: '0 2px 12px #00e0ff18', 
                padding: 'clamp(10px, 2vw, 14px)', 
                minWidth: 0, 
                width: isMobile ? '100%' : '50%'
              }}>
                <BlocoCampos
                  onAbrirMapa={() => { setMostrarMapa(true); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                  lado={lado}
                  profundas={profundas[lado]}
                  superficiais={superficiais[lado]}
                  magna={magna[lado]}
                  parva={parva[lado]}
                  perfurantes={perfurantes[lado]}
                  onProfundas={val => setProfundas(prev => ({ ...prev, [lado]: val }))}
                  onSuperficiais={val => setSuperficiais(prev => ({ ...prev, [lado]: val }))}
                  onMagna={val => setMagna(prev => ({ ...prev, [lado]: val }))}
                  onParva={val => setParva(prev => ({ ...prev, [lado]: val }))}
                  onPerfurantes={val => setPerfurantes(prev => ({ ...prev, [lado]: val }))}
                  jsfDiametro={typeof jsfDiametro[lado] === 'string' ? jsfDiametro[lado] : ''}
                  setJsfDiametro={v => setJsfDiametro(prev => ({ ...prev, [lado]: v }))}
                  jspDiametro={typeof jspDiametro[lado] === 'string' ? jspDiametro[lado] : ''}
                  setJspDiametro={v => setJspDiametro(prev => ({ ...prev, [lado]: v }))}
                  observacao={observacoes[lado]}
                  onObservacao={val => setObservacoes(prev => ({ ...prev, [lado]: val }))}
                  varizes={varizes[lado]}
                  onVarizes={val => setVarizes(prev => ({ ...prev, [lado]: val }))}
                />
              </div>
              {/* Laudo ao lado direito para lado único */}
              {laudoTexto && (
                <div style={{
                  background: "#fff",
                  color: "#222",
                  borderRadius: 'clamp(8px, 1.5vw, 12px)',
                  padding: 'clamp(12px, 2.5vw, 20px)',
                  boxShadow: "0 8px 32px #00e0ff33",
                  fontFamily: "monospace",
                  fontSize: 'clamp(11px, 2.2vw, 13px)',
                  lineHeight: 1.5,
                  whiteSpace: "pre-wrap",
                  width: isMobile ? '100%' : '50%',
                  maxHeight: "75vh",
                  overflowY: "auto"
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 'clamp(6px, 1.5vw, 8px)', marginBottom: 'clamp(6px, 1.5vw, 8px)' }}>
                    <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 'clamp(10px, 2vw, 12px)', color: "#333", cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={incluirEsquemaPdf}
                        onChange={e => setIncluirEsquemaPdf(e.target.checked)}
                      />
                      Incluir Mapeamento Visual no PDF
                    </label>
                    <div style={{ display: "flex", gap: 'clamp(6px, 1.5vw, 8px)', flexWrap: "wrap" }}>
                    <button style={{ ...buttonStyle, background: "#6f42c1", fontSize: 'clamp(10px, 2vw, 12px)', padding: "clamp(4px, 1.5vw, 6px) clamp(8px, 2vw, 12px)", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6 }} onClick={() => setMostrarEsquema(true)}>
                      <FaStethoscope /> Mapeamento Visual
                    </button>
                    <button style={{
                      ...buttonStyle,
                      background: "#0eb8d0",
                      color: "#fff",
                      fontSize: 'clamp(10px, 2vw, 12px)',
                      padding: "clamp(4px, 1.5vw, 6px) clamp(8px, 2vw, 12px)"
                    }} onClick={handleSalvarTXT}>Salvar TXT</button>
                    <button style={{
                      ...buttonStyle,
                      background: "#0eb8d0",
                      color: "#fff",
                      fontSize: 'clamp(10px, 2vw, 12px)',
                      padding: "clamp(4px, 1.5vw, 6px) clamp(8px, 2vw, 12px)"
                    }} onClick={handleSalvarPDF}>Salvar PDF</button>
                    </div>
                  </div>
                  {laudoTexto}
                </div>
              )}

              {/* Caixa de Anexos Compacta - aparece apenas quando o preview está visível */}
              {laudoTexto && (
                <div style={{
                  width: '100%',
                  maxWidth: 'min(1200px, 98vw)',
                  margin: 'clamp(8px, 1.5vw, 12px) auto 0 auto',
                  background: '#18243a',
                  borderRadius: 'clamp(6px, 1.2vw, 8px)',
                  padding: 'clamp(8px, 1.5vw, 12px)',
                  boxShadow: '0 2px 8px #00e0ff15',
                  border: '1px solid #0eb8d0'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 'clamp(6px, 1.2vw, 8px)'
                  }}>
                    <h3 style={{
                      margin: 0,
                      color: '#0eb8d0',
                      fontSize: 'clamp(12px, 2vw, 14px)',
                      fontWeight: 600,
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6
                    }}>
                      <FiPaperclip /> Anexos
                    </h3>
                    <span style={{
                      color: '#888',
                      fontSize: 'clamp(10px, 1.6vw, 12px)'
                    }}>
                      {anexos.length} arquivo(s)
                    </span>
                  </div>
                  
                  {/* Área de Upload Compacta */}
                  <div
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    style={{
                      border: '1px dashed #0eb8d0',
                      borderRadius: 'clamp(4px, 1vw, 6px)',
                      padding: 'clamp(8px, 1.5vw, 12px)',
                      textAlign: 'center',
                      background: 'rgba(14, 184, 208, 0.03)',
                      marginBottom: 'clamp(6px, 1.2vw, 8px)',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease'
                    }}
                    onClick={() => document.getElementById('fileInput').click()}
                  >
                    <input
                      id="fileInput"
                      type="file"
                      accept=".png,.jpg,.jpeg"
                      multiple
                      onChange={handleFileUpload}
                      style={{ display: 'none' }}
                    />
                    <div style={{ color: '#0eb8d0', fontSize: 'clamp(11px, 1.8vw, 13px)' }}>
                      Clique ou arraste para anexar (PNG/JPG até 15MB)
                    </div>
                  </div>
                  
                  {/* Lista de Anexos Compacta */}
                  {anexos.length > 0 && (
                    <div style={{
                      maxHeight: 'clamp(80px, 15vh, 120px)',
                      overflowY: 'auto',
                      border: '1px solid #333',
                      borderRadius: 'clamp(3px, 0.8vw, 4px)',
                      background: '#1a1a1a',
                      padding: 'clamp(4px, 1vw, 6px)'
                    }}>
                      {anexos.map(anexo => (
                        <div key={anexo.id} style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 'clamp(6px, 1.5vw, 8px)',
                          padding: 'clamp(4px, 1vw, 6px)',
                          background: '#222',
                          borderRadius: 'clamp(3px, 0.8vw, 4px)',
                          marginBottom: 'clamp(2px, 0.8vw, 3px)',
                          border: '1px solid #444'
                        }}>
                          {/* Thumbnail Menor */}
                          <img
                            src={anexo.thumbnail}
                            alt={anexo.name}
                            style={{
                              width: 'clamp(30px, 6vw, 35px)',
                              height: 'clamp(30px, 6vw, 35px)',
                              objectFit: 'cover',
                              borderRadius: 'clamp(2px, 0.6vw, 3px)',
                              border: '1px solid #666'
                            }}
                          />
                          
                          {/* Info do arquivo Compacta */}
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{
                              color: '#fff',
                              fontSize: 'clamp(10px, 1.6vw, 12px)',
                              fontWeight: 500,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              marginBottom: 'clamp(1px, 0.3vw, 2px)'
                            }}>
                              {anexo.name}
                            </div>
                            <div style={{
                              color: '#888',
                              fontSize: 'clamp(9px, 1.4vw, 11px)'
                            }}>
                              {formatFileSize(anexo.size)}
                            </div>
                          </div>
                          
                          {/* Botão remover Menor */}
                          <button
                            onClick={() => removeAnexo(anexo.id)}
                            style={{
                              background: '#ff4444',
                              color: '#fff',
                              border: 'none',
                              borderRadius: 'clamp(2px, 0.6vw, 3px)',
                              padding: 'clamp(3px, 0.8vw, 4px) clamp(6px, 1.5vw, 8px)',
                              fontSize: 'clamp(9px, 1.4vw, 11px)',
                              cursor: 'pointer',
                              fontWeight: 500,
                              display: 'inline-flex',
                              alignItems: 'center',
                              transition: 'background 0.2s ease'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.background = '#cc3333'}
                            onMouseOut={(e) => e.currentTarget.style.background = '#ff4444'}
                          >
                            <FiX />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
          
          {/* Layout para ambos os lados */}
          {lado === "Ambos" && (
            <>
              <div style={{
                background: '#18243a', 
                borderRadius: 'clamp(8px, 1.5vw, 12px)', 
                boxShadow: '0 2px 12px #00e0ff18', 
                padding: 'clamp(10px, 2vw, 14px)', 
                minWidth: 0, 
                width: isMobile ? '100%' : '50%', 
                maxWidth: isMobile ? '100%' : 700, 
                marginRight: isMobile ? 0 : 'clamp(6px, 1.5vw, 10px)'
              }}>
                <BlocoCampos
                  onAbrirMapa={() => { setMostrarMapa(true); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                  lado="Direito"
                  profundas={profundas.Direito}
                  superficiais={superficiais.Direito}
                  magna={magna.Direito}
                  parva={parva.Direito}
                  perfurantes={perfurantes.Direito}
                  onProfundas={val => setProfundas(prev => ({ ...prev, Direito: val }))}
                  onSuperficiais={val => setSuperficiais(prev => ({ ...prev, Direito: val }))}
                  onMagna={val => setMagna(prev => ({ ...prev, Direito: val }))}
                  onParva={val => setParva(prev => ({ ...prev, Direito: val }))}
                  onPerfurantes={val => setPerfurantes(prev => ({ ...prev, Direito: val }))}
                  jsfDiametro={typeof jsfDiametro.Direito === 'string' ? jsfDiametro.Direito : ''}
                  setJsfDiametro={v => setJsfDiametro(prev => ({ ...prev, Direito: v }))}
                  jspDiametro={typeof jspDiametro.Direito === 'string' ? jspDiametro.Direito : ''}
                  setJspDiametro={v => setJspDiametro(prev => ({ ...prev, Direito: v }))}
                  observacao={observacoes.Direito}
                  onObservacao={val => setObservacoes(prev => ({ ...prev, Direito: val }))}
                  varizes={varizes.Direito}
                  onVarizes={val => setVarizes(prev => ({ ...prev, Direito: val }))}
                />
              </div>
              <div style={{
                background: '#18243a', 
                borderRadius: 'clamp(8px, 1.5vw, 12px)', 
                boxShadow: '0 2px 12px #00e0ff18', 
                padding: 'clamp(10px, 2vw, 14px)', 
                minWidth: 0, 
                width: isMobile ? '100%' : '50%', 
                maxWidth: isMobile ? '100%' : 700, 
                marginLeft: isMobile ? 0 : 'clamp(6px, 1.5vw, 10px)'
              }}>
                <BlocoCampos
                  onAbrirMapa={() => { setMostrarMapa(true); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                  lado="Esquerdo"
                  profundas={profundas.Esquerdo}
                  superficiais={superficiais.Esquerdo}
                  magna={magna.Esquerdo}
                  parva={parva.Esquerdo}
                  perfurantes={perfurantes.Esquerdo}
                  onProfundas={val => setProfundas(prev => ({ ...prev, Esquerdo: val }))}
                  onSuperficiais={val => setSuperficiais(prev => ({ ...prev, Esquerdo: val }))}
                  onMagna={val => setMagna(prev => ({ ...prev, Esquerdo: val }))}
                  onParva={val => setParva(prev => ({ ...prev, Esquerdo: val }))}
                  onPerfurantes={val => setPerfurantes(prev => ({ ...prev, Esquerdo: val }))}
                  jsfDiametro={typeof jsfDiametro.Esquerdo === 'string' ? jsfDiametro.Esquerdo : ''}
                  setJsfDiametro={v => setJsfDiametro(prev => ({ ...prev, Esquerdo: v }))}
                  jspDiametro={typeof jspDiametro.Esquerdo === 'string' ? jspDiametro.Esquerdo : ''}
                  setJspDiametro={v => setJspDiametro(prev => ({ ...prev, Esquerdo: v }))}
                  observacao={observacoes.Esquerdo}
                  onObservacao={val => setObservacoes(prev => ({ ...prev, Esquerdo: val }))}
                  varizes={varizes.Esquerdo}
                  onVarizes={val => setVarizes(prev => ({ ...prev, Esquerdo: val }))}
                />
              </div>
            </>
          )}
        </div>

      </div>
      )}
      {/* Exibição do laudo ao lado (lado único) ou embaixo (ambos) */}
      {laudoTexto && lado === "Ambos" && (
        <div style={{
          flex: 1,
          minWidth: "clamp(280px, 90vw, 320px)",
          maxWidth: 'min(1200px, 98vw)',
          marginTop: 'clamp(12px, 2vw, 16px)',
          background: "#fff",
          color: "#222",
          borderRadius: 'clamp(8px, 1.5vw, 12px)',
          padding: 'clamp(12px, 2.5vw, 20px)',
          boxShadow: "0 8px 32px #00e0ff33",
          fontFamily: "monospace",
          fontSize: 'clamp(11px, 2.2vw, 13px)',
          lineHeight: 1.5,
          whiteSpace: "pre-wrap",
          maxHeight: "75vh",
          overflowY: "auto"
        }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 'clamp(6px, 1.5vw, 8px)',
            marginBottom: 'clamp(6px, 1.5vw, 8px)'
          }}>
            <label style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 'clamp(10px, 2vw, 12px)', color: "#333", cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={incluirEsquemaPdf}
                onChange={e => setIncluirEsquemaPdf(e.target.checked)}
              />
              Incluir Mapeamento Visual no PDF
            </label>
            <div style={{ display: "flex", gap: 'clamp(6px, 1.5vw, 8px)', flexWrap: "wrap" }}>
            <button style={{ ...buttonStyle, background: "#6f42c1", fontSize: 'clamp(10px, 2vw, 12px)', padding: "clamp(4px, 1.5vw, 6px) clamp(8px, 2vw, 12px)", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6 }} onClick={() => setMostrarEsquema(true)}>
              <FaStethoscope /> Mapeamento Visual
            </button>
            <button style={{
              ...buttonStyle,
              background: "#0eb8d0",
              color: "#fff",
              fontSize: 'clamp(10px, 2vw, 12px)',
              padding: "clamp(4px, 1.5vw, 6px) clamp(8px, 2vw, 12px)"
            }} onClick={handleSalvarTXT}>Salvar TXT</button>
            <button style={{
              ...buttonStyle,
              background: "#0eb8d0",
              color: "#fff",
              fontSize: 'clamp(10px, 2vw, 12px)',
              padding: "clamp(4px, 1.5vw, 6px) clamp(8px, 2vw, 12px)"
            }} onClick={handleSalvarPDF}>Salvar PDF</button>
            </div>
          </div>
          {laudoTexto}
        </div>
      )}

      {/* Caixa de Anexos Compacta para layout "Ambos" - aparece apenas quando o preview está visível */}
      {laudoTexto && lado === "Ambos" && (
        <div style={{
          width: '100%',
          maxWidth: 'min(1200px, 98vw)',
          margin: 'clamp(8px, 1.5vw, 12px) auto 0 auto',
          background: '#18243a',
          borderRadius: 'clamp(6px, 1.2vw, 8px)',
          padding: 'clamp(8px, 1.5vw, 12px)',
          boxShadow: '0 2px 8px #00e0ff15',
          border: '1px solid #0eb8d0'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 'clamp(6px, 1.2vw, 8px)'
          }}>
            <h3 style={{
              margin: 0,
              color: '#0eb8d0',
              fontSize: 'clamp(12px, 2vw, 14px)',
              fontWeight: 600,
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6
            }}>
              <FiPaperclip /> Anexos
            </h3>
            <span style={{
              color: '#888',
              fontSize: 'clamp(10px, 1.6vw, 12px)'
            }}>
              {anexos.length} arquivo(s)
            </span>
          </div>
          
          {/* Área de Upload Compacta */}
          <div
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            style={{
              border: '1px dashed #0eb8d0',
              borderRadius: 'clamp(4px, 1vw, 6px)',
              padding: 'clamp(8px, 1.5vw, 12px)',
              textAlign: 'center',
              background: 'rgba(14, 184, 208, 0.03)',
              marginBottom: 'clamp(6px, 1.2vw, 8px)',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onClick={() => document.getElementById('fileInputAmbos').click()}
          >
            <input
              id="fileInputAmbos"
              type="file"
              accept=".png,.jpg,.jpeg"
              multiple
              onChange={handleFileUpload}
              style={{ display: 'none' }}
            />
            <div style={{ color: '#0eb8d0', fontSize: 'clamp(11px, 1.8vw, 13px)' }}>
              Clique ou arraste para anexar (PNG/JPG até 15MB)
            </div>
          </div>
          
          {/* Lista de Anexos Compacta */}
          {anexos.length > 0 && (
            <div style={{
              maxHeight: 'clamp(80px, 15vh, 120px)',
              overflowY: 'auto',
              border: '1px solid #333',
              borderRadius: 'clamp(3px, 0.8vw, 4px)',
              background: '#1a1a1a',
              padding: 'clamp(4px, 1vw, 6px)'
            }}>
              {anexos.map(anexo => (
                <div key={anexo.id} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'clamp(6px, 1.5vw, 8px)',
                  padding: 'clamp(4px, 1vw, 6px)',
                  background: '#222',
                  borderRadius: 'clamp(3px, 0.8vw, 4px)',
                  marginBottom: 'clamp(2px, 0.8vw, 3px)',
                  border: '1px solid #444'
                }}>
                  {/* Thumbnail Menor */}
                  <img
                    src={anexo.thumbnail}
                    alt={anexo.name}
                    style={{
                      width: 'clamp(30px, 6vw, 35px)',
                      height: 'clamp(30px, 6vw, 35px)',
                      objectFit: 'cover',
                      borderRadius: 'clamp(2px, 0.6vw, 3px)',
                      border: '1px solid #666'
                    }}
                  />
                  
                  {/* Info do arquivo Compacta */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                      color: '#fff',
                      fontSize: 'clamp(10px, 1.6vw, 12px)',
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      marginBottom: 'clamp(1px, 0.3vw, 2px)'
                    }}>
                      {anexo.name}
                    </div>
                    <div style={{
                      color: '#888',
                      fontSize: 'clamp(9px, 1.4vw, 11px)'
                    }}>
                      {formatFileSize(anexo.size)}
                    </div>
                  </div>
                  
                  {/* Botão remover Menor */}
                  <button
                    onClick={() => removeAnexo(anexo.id)}
                    style={{
                      background: '#ff4444',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 'clamp(2px, 0.6vw, 3px)',
                      padding: 'clamp(3px, 0.8vw, 4px) clamp(6px, 1.5vw, 8px)',
                      fontSize: 'clamp(9px, 1.4vw, 11px)',
                      cursor: 'pointer',
                      fontWeight: 500,
                      display: 'inline-flex',
                      alignItems: 'center',
                      transition: 'background 0.2s ease'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.background = '#cc3333'}
                    onMouseOut={(e) => e.currentTarget.style.background = '#ff4444'}
                  >
                    <FiX />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      <EsquemaMapeamentoModal
        aberto={mostrarEsquema}
        onFechar={() => setMostrarEsquema(false)}
        lado={lado}
        nome={nome}
        data={data}
        superficiais={superficiais}
        magna={magna}
        parva={parva}
        perfurantes={perfurantes}
        profundas={profundas}
        varizes={varizes}
        observacoes={observacoes}
      />
      <style>{`
        @keyframes logoGlow {
          0% {
            filter: drop-shadow(0 10px 32px #00e0ff90);
          }
          100% {
            filter: drop-shadow(0 18px 48px #00e0ffc0);
          }
        }
      `}</style>
    </div>
  );
}

const inputStyle = {
  background: "#f7fbff",
  border: "1.5px solid #0eb8d0",
  borderRadius: "clamp(5px, 1vw, 7px)",
  padding: "clamp(6px, 1.5vw, 8px) clamp(8px, 2vw, 12px)",
  fontSize: "clamp(13px, 2.5vw, 15px)",
  color: "#222",
  outline: "none",
  fontFamily: "inherit",
  fontWeight: 500,
  width: "clamp(140px, 25vw, 180px)",
  minWidth: 0
};

const buttonStyle = {
  background: "#0eb8d0",
  color: "#fff",
  fontWeight: 600,
  fontSize: "clamp(14px, 2.5vw, 16px)",
  padding: "clamp(8px, 2vw, 10px) clamp(16px, 3vw, 22px)",
  border: "none",
  borderRadius: "clamp(6px, 1.5vw, 8px)",
  cursor: "pointer",
  letterSpacing: 0.5,
  boxShadow: "0 2px 10px #00e0ff30",
  transition: ".2s",
  marginLeft: "clamp(6px, 1.5vw, 8px)",
  minWidth: "clamp(120px, 20vw, 140px)"
};

export default MMIIVenoso; 